export enum LayoutTypes {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum LayoutModeTypes {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum LayoutWidthTypes {
  FLUID = 'fluid',
  BOXED = 'boxed',
  SCROLLABLE = 'scrollable',
}

export enum TopbarThemeTypes {
  LIGHT = 'light',
  DARK = 'dark',
  COLORED = 'colored',
}

export enum LeftSidebarTypes {
  DEFAULT = 'default',
  COMPACT = 'small',
  ICON = 'icon',
}

export enum LeftSidebarThemeTypes {
  LIGHT = 'light',
  COLORED = 'colored',
  DARK = 'dark',
  WINTER = 'winter',
  LADYLIP = 'ladylip',
  PLUMPLATE = 'plumplate',
  STRONGBLISS = 'strongbliss',
  GREATWHALE = 'greatwhale',
}

export enum LeftbarThemeImagesTypes {
  NONE = 'none',
  IMG1 = 'img1',
  IMG2 = 'img2',
  IMG3 = 'img3',
  IMG4 = 'img4',
}
